import React from "react";
import { BrowserNotSupportedOutlined } from "@mui/icons-material";

export default function NotFound() {
  return (
    <div className="not-found">
      <BrowserNotSupportedOutlined className="not-found-icon" />
      <h1>404: Not Found</h1>
      <p>Sorry, this page does not exist.</p>
    </div>
  );
}
